import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { NOT_LOADED } from "../Infra/RemoteData";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { PageWithFixedHeaderAndFooterContent, PatientConsentParent } from "./PatientConsentManagerShared.styles";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { ScreenshotReadinessDetector } from "./ScreenshotReadinessDetector";
import { useViewModel } from "./useViewModel";
import { RequestDetailsView } from "./RequestDetailsView";
export const PatientConsentRequestDetailsView = observer((props) => {
    const model = useViewModel(PatientConsentViewModel, props.container);
    if (model.studyInfo === NOT_LOADED)
        return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
    if (!model.isInConsentFlow)
        return null;
    return (_jsx(ScreenshotReadinessDetector, { isScreenshotMode: model.isScreenshotMode, children: _jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: model.isHeaderAndFooterFixed, children: _jsx(PatientConsentParent, { children: _jsx(RequestDetailsView, { container: props.container, hideTitle: props.hideTitle, onViewImage: props.onViewImage }) }) }) }));
});
